exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TarifficationOfLimits_title_13Gc {\n  margin-bottom: 24px;\n}\n\n.TarifficationOfLimits_services_1fFa {\n  margin-bottom: 36px;\n\n  display: grid;\n\n  grid-row-gap: 16px;\n}\n\n.TarifficationOfLimits_unit_WTuw {\n  display: grid;\n\n  grid-row-gap: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"title": "TarifficationOfLimits_title_13Gc",
	"services": "TarifficationOfLimits_services_1fFa",
	"unit": "TarifficationOfLimits_unit_WTuw"
};